// extracted by mini-css-extract-plugin
export default {"input-text":"TextAreaForm_input-text__7q+7D"};